/**
 * @generated SignedSource<<f0335faf66bfb13b5b794745ab30afda>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MessageSenderScreen_Query$variables = {
  messageDefinitionId: string;
};
export type MessageSenderScreen_Query$data = {
  readonly node: {
    readonly id: string;
    readonly internalTitle?: string;
  } | null | undefined;
};
export type MessageSenderScreen_Query = {
  response: MessageSenderScreen_Query$data;
  variables: MessageSenderScreen_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "messageDefinitionId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "messageDefinitionId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "internalTitle",
      "storageKey": null
    }
  ],
  "type": "MessageDefinition",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MessageSenderScreen_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MessageSenderScreen_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0f5e19b65be6dd69568dbc9d951a8e97",
    "id": null,
    "metadata": {},
    "name": "MessageSenderScreen_Query",
    "operationKind": "query",
    "text": "query MessageSenderScreen_Query(\n  $messageDefinitionId: ID!\n) {\n  node(id: $messageDefinitionId) {\n    __typename\n    id\n    ... on MessageDefinition {\n      internalTitle\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c8e790340c5775a6b912609fd2cf829e";

export default node;
